import React from "react";
import PropTypes from "prop-types";

/**
 * BaseBlock - print wrapper for board-report blocks (see Task 7 block components).
 *
 * Exposes `data-widget-loading` on its root element, mirroring
 * src/components/widgets/BaseWidget.jsx, so the backend chromedp PDF poller
 * (src/views/reports/ReportPrint.jsx) can detect when every block on the
 * page has finished loading before it captures the PDF.
 *
 * Error states still resolve `data-widget-loading` to "false" so the PDF
 * completes rather than hanging on a block whose data-fetch failed.
 */
const BaseBlock = ({ title, isLoading = false, error = null, className = "", children }) => {
  const wrapperClassName = ["a4-block", className].filter(Boolean).join(" ");

  return (
    <div
      className={wrapperClassName}
      data-widget-loading={isLoading ? "true" : "false"}
    >
      {title && <h3 className="a4-block-title">{title}</h3>}

      {isLoading && (
        <div className="a4-block-loading" aria-hidden="true" />
      )}

      {!isLoading && error && (
        <p className="a4-block-error">Data unavailable</p>
      )}

      {!isLoading && !error && children}
    </div>
  );
};

BaseBlock.propTypes = {
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Error)]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default BaseBlock;
